import { type Meta } from '../types/docs';

const META: Meta = {
  description:
    'User clicked to save one or more canvas results as new versions on the asset they opened the canvas from (version target).',
  name: 'canvas_save_to_original_asset_clicked',
  params: [
    {
      description: 'The id of the canvas, omitted while the canvas is still an unsaved draft',
      name: 'canvas_id',
      required: false,
      type: 'string',
    },
    {
      description: 'Where the save-to-original-asset action was taken',
      name: 'location',
      required: true,
      type: 'enum',
      values: ['save_menu', 'hover_button', 'follow_up_row', 'follow_up_save_all'],
    },
    {
      description: 'How many canvas results this click saves (1 except Save all)',
      name: 'node_count',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
